import project from '@/view/agri/project/index.vue'
import contract from '@/view/agri/contract/index.vue'
import orderPurchase from '@/view/agri/orderPurchase/index.vue'
import orderDelivery from '@/view/agri/orderDelivery/index.vue'
import creditPay from '@/view/agri/creditPay/index.vue'


export default [
    { path: '/agri/project', component: project, meta: '项目管理' },
    { path: '/agri/contract', component: contract, meta: '合同管理' },
    { path: '/agri/orderPurchase', component: orderPurchase, meta: '采购单' },
    { path: '/agri/orderDelivery', component: orderDelivery, meta: '配送单' },
    { path: '/agri/creditPay', component: creditPay, meta: '融资支付' },

]
